<template>
  <div class="dboard-card">
    <loading-progress
      v-if="isLoading"
      :progress="60"
      :indeterminate=true
      :hide-background="true"
      size="64"
      rotate
      fillDuration="2"
      rotationDuration="1"
    />
    <div class="row" v-else>
      <div class="col-lg-12" v-if = "selectedDepot !=null">
        <div class="dboard-card-title" >
          Truck Time Compliance
        </div>
        <div class="dboard-card-panel">
          <div class="dboard-card-panel-section">
            <div>
              <div class="bar-section">
                <div class="bar-section-title">Gate</div>
                <div class="bar-section-dropdown">
                  <FilterDropdown :options="gates"
                  :selected="selectedGate"
                  @updateOption="gateSelected"/>
                </div>
              </div>
            </div>
            <loading-progress
              v-if="isFetch"
              :progress="60"
              :indeterminate=true
              :hide-background="true"
              size="64"
              rotate
              fillDuration="2"
              rotationDuration="1"
            />
            <div v-else>
              <div v-if="!noRecord">
                <div>
                  <div class="bar-section">
                    <StackChart :series="finalseries" />
                  </div>
                </div>
                <!--
                <div class="bottom-section">
                  <div class="bottom-title">
                    % Compliance as follows STD Time (In Mins)
                  </div>
                  <div class="complaince-container">
                    <div class="complaince-row">
                      <div class="complaince-cell">
                        <span class="complaince-text">Truck In to Loading</span>
                      </div>
                      <div class="complaince-cell">
                        <span class="complaince-number">15</span>
                      </div>
                    </div>
                    <div class="complaince-row">
                      <div class="complaince-cell">
                        <span class="complaince-text">
                          Loading Start - Loading End
                        </span>
                      </div>
                      <div class="complaince-cell">
                        <span class="complaince-number">15</span>
                      </div>
                    </div>
                    <div class="complaince-row">
                      <div class="complaince-cell">
                        <span class="complaince-text">
                          Loading End - Truck Out
                        </span>
                      </div>
                      <div class="complaince-cell">
                        <span class="complaince-number">15</span>
                      </div>
                    </div>
                  </div>
                </div>
              -->
              </div>
              <div class="bar-section-title" v-else>
                No Records
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import FilterDropdown from '@common/components/FilterDropdown';
import StackChart from '../common/charts/StackChart';

const serierMap = [
  { name: '< 1.2 STD Time', index: 1 },
  { name: '> 1.2 STD Time', index: 2 },
  { name: '< STD Time', index: 0 },
];

const stackMap = ['arrival_sla', 'loading_sla', 'dispatch_sla'];
const slamap = [
  [ 'SLA: < 30 Mins', 'SLA: < 30×1.2 Mins', 'SLA Breach: > 30×1.2 Mins' ],
  [ 'SLA: < 3Hr', 'SLA: < 3×1.2 Hr', 'SLA Breach: > 3×1.2 Hr' ],
  [ 'SLA: < 2.5Hr', 'SLA: < 2.5×1.2 Hr', 'SLA Breach: > 2.5×1.2 Hr' ]
];

export default {
  props: {
    selectedDepot: {
      type: Object,
    },
    selectedMonth: {
      type: Object,
    },
    selectedYear: {
      type: Object,
    },
    day: {
      type: Object,
    },
    selectedTransporter: {
      type: Object,
    },
  },
  components: {
    FilterDropdown,
    StackChart,
  },
  data() {
    const selectedGate = this.selectedDepot
   && this.selectedDepot.gates.length > 0
   ? this.selectedDepot.gates[0] : null;
    return {
      isLoading: false,
      selectedGate,
      isFetch: false,
      finalseries: null,
      noRecord: false,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      if (!this.isFetch) {
        this.isFetch = true;
        let params = {
          year: this.selectedYear.name,
          depot_id: this.selectedDepot.id,
          gate_id: this.selectedGate.id };
        params = this.prepareResponse(params);
        const result = await this.$store.dispatch('dashboard/gatesla', params);
        // progress feedback time
        // await (new Promise(resolve => setTimeout(resolve, 1000)));
        this.processSla(result);
        this.isFetch = false;
      }
    },
    gateSelected(gate) {
      this.selectedGate = gate;
      this.fetch();
    },
    prepareResponse(obj) {
      if (this.day && this.day.id !== 0) {
        let date = new Date();
        date.setYear(this.selectedYear.name);
        date.setMonth(this.selectedMonth.id - 1);
        date.setDate(this.day.name);
        obj.date = date.toISOString();
        delete obj.year;
      } else {
        obj.month = this.selectedMonth.name.toLowerCase();
      }
      if (this.selectedTransporter && this.selectedTransporter.id !== 0) {
        obj.transporter_id = this.selectedTransporter.id;
      }
      return obj;
    },
    processSla(sladata) {
      if (sladata.arrival_sla
        && sladata.arrival_sla.length > 0
        && sladata.loading_sla
        && sladata.loading_sla.length > 0
        && sladata.dispatch_sla
        && sladata.dispatch_sla.length > 0) {
        let finalsla = {};
        let finalseries = {};
        stackMap.forEach((stack)=>{
          let sum = sladata[stack].reduce((acc, sla) => Number(acc) + Number(sla), 0);
          finalsla[stack] = sladata[stack].map((i)=>Number(Number((i/sum)*100).toFixed(2)));
        });

        serierMap.forEach((series)=>{
          stackMap.forEach((stack, stindex)=>{
            if (!finalseries[series.name]) {
              finalseries[series.name] = [];
            }
            finalseries[series.name].push({ y: finalsla[stack][series.index],
              real: sladata[stack][series.index],
              sla: slamap[stindex][series.index], });
          });
        });
        this.finalseries = finalseries;
      } else {
        this.noRecord = true;
      }
    },
  },
  computed: {
    gates() {
      return this.selectedDepot.gates;
    },

  },
  watch: {
    selectedMonth() {
      this.fetch();
    },
    day() {
      this.fetch();
    },
    selectedDepot() {
      this.fetch();
    },
    selectedTransporter() {
      this.fetch();
    },
    selectedYear() {
      this.fetch();
    },
  },
};
</script>
<style lang="scss" scoped>
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

.section-left {
  float: left;
}
.bottom-section {
  padding-top: 20px;
  padding-left: 20px;
}
.bottom-title {
  color: #CADCFF;
  font-family:$fontSemibold;
  font-size: 13px;
}
.complaince-container {
  display: table;
  margin-top: 10px;
}
.complaince-row {
  display: table-row;
}
.complaince-cell {
  display: table-cell;
  padding: 2px;
  padding-right: 5px;
  vertical-align: middle;
  &-number {
    text-align: right;
  }
}
.complaince-text {
  color: #CADCFF;
  font-size: 13px;
  line-height: 16px;
}
.complaince-number {
  color: #CADCFF;
  font-family:$fontSemibold;
  font-size: 16px;
  line-height: 20px;
}
</style>
